var _path, _rect;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSpotify = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "spotify",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "spotify-2",
    "data-name": "spotify",
    d: "M7.25,14.5A7.25,7.25,0,1,0,0,7.25,7.253,7.253,0,0,0,7.25,14.5Zm2.944-3.833h0c-.488,0-2.028-1.709-6.356-.822a1.866,1.866,0,0,1-.348.076.48.48,0,0,1-.064-.953,9.334,9.334,0,0,1,6.928.766.486.486,0,0,1-.16.932Zm.787-1.917c-.068-.018-.048.042-.361-.123a9.474,9.474,0,0,0-6.975-.86,1.2,1.2,0,0,1-.348.076.594.594,0,0,1-.114-1.172,10.591,10.591,0,0,1,8.034.932.61.61,0,0,1,.33.576A.567.567,0,0,1,10.981,8.75ZM2.748,4.228a13.448,13.448,0,0,1,9.44.953.711.711,0,0,1-.3,1.341h0a.673.673,0,0,1-.378-.114A12.084,12.084,0,0,0,3.3,5.54a1.407,1.407,0,0,1-.378.076.675.675,0,0,1-.681-.69.691.691,0,0,1,.509-.7Z",
    transform: "translate(7.25 7.25)",
    fill: "#00b23e"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 29,
    height: 29,
    fill: "none"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpotify, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/spotify.3e53fdab.svg";
export { ForwardRef as ReactComponent };